import { translations } from "../../Translation/staticTranslation"

const lang = localStorage.getItem("language") || "ar"
const t = translations[lang]?.organizationPage?.actions

export const organizationMemberActions = (onAllocate, onReclaim) => [
  {
    button: () => (
      <button type="button" className="custom-view-btn">
        {t?.allocate || "Allocate"}
      </button>
    ),
    onClick: (row) => onAllocate(row),
    type: "button",
  },
  {
    button: () => (
      <button type="button" className="org-btn-outline">
        {t?.reclaim || "Reclaim"}
      </button>
    ),
    onClick: (row) => onReclaim(row),
    type: "button",
  },
]
